import { ScreenNames } from '@hrms/common/routes/screens';
import { ComponentsMap } from '@hrms/common/routes/components';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { ModuleConstants } from '@hrms/common/constant/modules';
import { generateImage } from '@hrms/common/utils/generateImage';

export const ftFlexBaseUrl = `/ft-flex`;

const getFTFlexModuleRoutes: ModuleRoutesComponentInterface = () => {
  return [
    {
      id: ModuleConstants.FT_FLEX_MANAGEMENT,
      route: ftFlexBaseUrl,
      title: ScreenNames.FT_FLEX,
      icon: generateImage({
        noScale: true,
        name: 'users',
        alt: 'ft-flex',
        className: 'w-4 h-4',
      }),
      component: null,
      children: [
        {
          id: ModuleConstants.FT_FLEX_SLOT_MANAGEMENT,
          route: `${ftFlexBaseUrl}/slot-management`,
          title: ScreenNames.SLOT_MANAGEMENT,
          component: ComponentsMap.FT_FLEX_SLOT_MANAGEMENT,
        },
        {
          id: ModuleConstants.FT_FLEX_RATE_CARD_MANAGEMENT,
          route: `${ftFlexBaseUrl}/rate-card-management`,
          title: ScreenNames.RATE_CARD_MANAGEMENT,
          component: ComponentsMap.FT_FLEX_RATE_CARD_MANAGEMENT,
        },
      ],
    },
  ];
};

export default getFTFlexModuleRoutes;
